import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, FormCheck, Row, Col, Tab, Tabs } from 'react-bootstrap';
import { getItemPowerReport, getOpReports } from '../../components/deityRequests';

const ItemPowerEditor = ({ itemHeader, show = false, handleClose }) => {
    const [itemPowerReport, setItemPowerReport] = useState();
    const [itemDetail, setItemDetail] = useState();
    const [error, setError] = useState(undefined);

    useEffect(() => {
        setItemPowerReport(itemHeader);
    }, [itemHeader]);


    useEffect(() => {
        if (show) {
            getItemDetail();
        }
    }, [itemPowerReport]);

    const getItemDetail = async () => {
        let data = await getItemPowerReport(itemHeader.item_index);
        if (data.result) {
            console.log(data);
            setItemDetail(data.report);
        } else {
            setItemDetail();
        }
    }

    const baseDetails = () => {
        return (<>
            <Row>
                <Col xl={1}>
                    <strong>name:</strong>
                </Col>

                <Col xl={11}>
                    <span>{itemDetail.name}</span>
                </Col>

            </Row>
            <Row>
                <Col xl={1}>
                    <strong>owner:</strong>
                </Col>

                <Col xl={11}>
                    <span>{itemDetail.owner}</span>
                </Col>
            </Row>

            <Row>
                <Col xl={1}>
                    <strong>location:</strong>
                </Col>

                <Col xl={11}>
                    <span>{itemDetail.location}</span>
                </Col>
            </Row>
            <Row>
                <Col xl={1}>
                    <strong>power:</strong>
                </Col>

                <Col xl={11}>
                    <span>{itemDetail.itemPower}</span>
                </Col>
            </Row>

                        <Row>
                <Col xl={1}>
                    <strong>item tps:</strong>
                </Col>

                <Col xl={11}>
                    <span>{itemDetail.itemTps}</span>
                </Col>
            </Row>
        </>);
    }

    const powerReport = () => {
        if (itemDetail === undefined) {
            return <span>Data goes here!</span>;
        } else {
            return (

                <Tabs defaultActiveKey="base" id="uncontrolled-tab-example">

                    <Tab eventKey="base" title="Overview">
                        {baseDetails()}
                    </Tab>
                    <Tab eventKey="empty" title="Empty">
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                    </Tab>

                </Tabs>


            )
        }
    }


    if (itemPowerReport === undefined)
        return <></>;

    return (
        <Modal className={"modal-editor"} size="xl" centered show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title>Maintaining Item: {itemPowerReport.item_name}</Modal.Title>
                <div className="alignright">
                    <small className="alignright" >owner {itemPowerReport.item_owner}</small>
                </div>
            </Modal.Header>
            <Modal.Body>
                {powerReport()}
                <Row className={"pt-4"}>
                    <Col>
                        <Button variant="secondary" onClick={handleClose}>
                            Delete
                        </Button>
                    </Col>
                    <Col>
                        <Button variant="secondary" onClick={handleClose}>
                            Rebalance
                        </Button>
                    </Col>
                    <Col>
                        <Button variant="secondary" onClick={handleClose}>
                            Modify
                        </Button>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>

                <Row>
                    <span className="error"><font color="red">{error}</font></span>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>

                </Row>
            </Modal.Footer>
        </Modal>);
}

export default ItemPowerEditor;